import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, FeatureFlagService } from "@obg/ngx.global";

import { BrandMigration, Jurisdiction } from "./jurisdiction.model";

@Injectable({
	providedIn: "root",
})
export class JurisdictionConfigService {
	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientCore>,
		private featureFlagService: FeatureFlagService
	) {}

	getCountryMapping(): Record<string, Jurisdiction> {
		return this.configService.get((x) => x.core.jurisdiction.countryMapping, {});
	}

	getDefaultJurisdiction(): Jurisdiction {
		const brandMigration = this.featureFlagService.get<BrandMigration | undefined>(
			"mga_to_tobique_jurisdiction"
		)?.tobiqueMigration;
		if (brandMigration?.tobiquePostMigrationIsEnabled) {
			return Jurisdiction.Tgc;
		}

		return this.configService.get((x) => x.core.jurisdiction.default, Jurisdiction.Mga) as Jurisdiction;
	}

	getJurisdictionEndpoint(): string {
		return this.configService.get((x) => x.core.jurisdiction.endpoints!.jurisdiction, "i18n/v1/jurisdiction");
	}
}
